// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Paper,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
// import CustomButton from "../../component/ui/FormFields/Button";
// import {
//   addAirportRequest,
//   resetAirportState,
// } from "../../redux/Airports/actions/airportActions";
// import {
//   selectCountryAirportRequest,
//   selectStateAirportRequest,
// } from "../../redux/Common/selectorAction";

// import {
//   AIRPORTS,
//   EDITPROMO,
//   PROMOCODE,
// } from "../../component/common/Routes/AppRoutes";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   LocationOn,
//   FlightLand,
//   FlightTakeoff,
//   TransferWithinAStation,
// } from "@mui/icons-material";
// import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
// import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
// import TextInputField from "../../component/ui/FormFields/TextInputField";
// import { resetUpdatePromoCode, updatePromoCodeRequest, viewPromoCodeRequest } from "../../redux/PromoCode/PromoCodeAction";
// import { formatDateWithAmPm } from "../../Style";
// import Loading from "../../component/ui/Loading";

// export default function EditPromoCode() {
//   const dispatch = useDispatch();
//   const {
//     control,
//     handleSubmit,
//     watch,
//     setValue,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {},
//     mode: "onChange",
//   });
//   const formValue = watch();
//   const user = useSelector((state) => state.auth.user);
//     const loading = useSelector((state) => state.promoCode.viewPromoCode.loading);
//     const updatePromoCodeLoading = useSelector((state) => state.promoCode.updatePromoCode.loading);
//     const updatePromoCodeSuccess = useSelector((state) => state.promoCode.updatePromoCode.success);
//     const updatePromoCodeError = useSelector((state) => state.promoCode.updatePromoCode.error);
//   const navigate = useNavigate();

//   const promoCodeDetails = useSelector(
//     (state) => state.promoCode?.viewPromoCode?.data || {}
//   );
//  let status = promoCodeDetails?.status === 1 ? 'Active' : 'Inactive';
//   const { id } = useParams();

// const [discountType, setDiscountType] = useState();
//   const promoFields = [
//     {
//       name: "title",
//       label: "Title *",
//       disabled:true,
//       placeholder: "Enter PromoCode Title",
//       rules: { required: "Discount Title is required" },
//       sm: 6,
//     },

//     {
//       name: "discount_code",
//        disabled:true,
//       label: "Discount Code *",
//       placeholder: "Enter Discount Code",
//       rules: {
//         required: "Discount Code is required",
//         validate: (value) => {
//           if (value.length < 4) {
//             return "Discount Code must be at least 4 characters";
//           }
//           if (value.length > 8) {
//             return "Discount Code must not exceed 8 characters";
//           }
//           return true;
//         },
//       },
//       sm: 6,
//     },
//    {
//       name: "discount_type",
//       label: "Discount Type",
//       placeholder: "Select Discount Type",
//       options: [
//         { value: "2", label: "Price ($)" },
//         { value: "1", label: "Discount(%)" },
//       ],
//       rules: {
//         required: "Select Discount Type",
//       },
//       sm: 6,
//     },
//     ...(discountType == "2"
//       ? [
//           {
//             name: "discount_value",
//             label: "Discount Value *",
//             placeholder: "Enter Discount Value",
//             rules: { required: "Discount Value is required" },
//             sm: 6,
//           },
//         ]
//       : [
//           {
//             name: "discount_percent",
//             label: "Discount Percentage *",
//             placeholder: "Enter Discount Percentage 0-100%",
//             rules: {
//               required: "Percentage is required",
//               min: { value: 0, message: "Percentage should not be negative" },
//               max: {
//                 value: 100,
//                 message: "Percentage must be less than or equal to 100",
//               },
//             },
//             sm: 6,
//           },
//         ]),
//     {
//       name: "usage_limit",
//       label: "Use Limit *",
//        disabled:true,
//       placeholder: "Set Promo Code Use Limit",
//       rules: {
//         required: "Promo Code Limit is Required",
//         min: { value: 1, message: "Usage limit must greater than 0" },
//       },

//       sm: 6,
//     },

//     {
//       name: "valid_from",
//       label: "Valid From *",
//       placeholder: "Select date ",
//       type: "dob",

//       instantBooking: "true",
//       rules: { required: "Date is required" },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "valid_to",
//       label: "Valid To *",
//       placeholder: "Select date ",

//       type: "dob",
//       instantBooking: "true",
//       rules: { required: "Date is required", validate: {} },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "description",
//        disabled:true,
//       label: "Description ",
//       placeholder: "Enter Promo Code Description ",
//       type: "textarea",

//       xs: 12,
//     },
//   ];
//  useEffect(()=>{

//       if(formValue.discount_type?.value=="1"){

//         setValue("discount_value","")
//       }
//       else{
//         setValue("discount_percent","")
//       }
//  },[formValue.discount_type])
//   useEffect(()=>{
//      setDiscountType(formValue?.discount_type?.value)
//   },[formValue.discount_type])
//   useEffect(() => {
//     if (id) {
//       dispatch(viewPromoCodeRequest(id));
//     }
//   }, [id]);
//   useEffect(() => {
//     if (Object.keys(promoCodeDetails).length > 0) {
//       setValue("title", promoCodeDetails.title);
//       setValue("discount_code", promoCodeDetails.discount_code);
//       setValue(
//         "discount_type",
//         promoCodeDetails.discount_type === 2
//           ? { value: 2, label: "Price ($)" }
//           : { value: 1, label: "Discount (%)" }
//       );
//       setValue("discount_value", promoCodeDetails.discount_value);
//       setValue("discount_percent", promoCodeDetails.discount_percent);
//       setValue("usage_limit", promoCodeDetails.usage_limit);
//       setValue("valid_from", formatDateWithAmPm(promoCodeDetails.valid_from));
//       setValue("valid_to", formatDateWithAmPm(promoCodeDetails.valid_to));
//       setValue("description", promoCodeDetails.description);
//       setValue("status", promoCodeDetails.status === 1 ? "Active" : "Inactive");

//     }

//   }, [promoCodeDetails]);
//      const onSubmit = (data) => {
//       const formattedData={
//         ...data,
//         id:id,
//         discount_type:data.discount_type.value,
//         discount_percent:data.discount_percent||0,
//         discount_value:data.discount_value||0,
//              status: data.status === 'Active' ? '1' : '2',

//       }
//       dispatch(updatePromoCodeRequest(formattedData));
//     };
//       if (loading) {
//           return <Loading text="Loading Promo Code Details..." />;
//       }
//         if (updatePromoCodeSuccess) {
//           toast.success(updatePromoCodeSuccess, {
//             position: 'top-center',
//             autoClose: 3000,
//             onClose: () => {
//               dispatch(resetUpdatePromoCode());
//               navigate(PROMOCODE);
//             },
//           });
//         }
//         if (updatePromoCodeError) {
//           toast.error(updatePromoCodeError, {
//             position: 'top-center',
//             autoClose: 3000,
//             onClose: () => {
//               dispatch(resetUpdatePromoCode());
//               navigate(PROMOCODE);
//             },
//           });
//         }
//   return (
//     <Box component={Paper} sx={{ margin: "30px", padding: "30px" }}>
//       <Typography variant="h5" mb={2}>
//         Edit PromoCode
//       </Typography>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <Grid container spacing={2}>
//           {promoFields.map((field) => (
//             <Grid item xs={12} sm={field.sm} key={field.name}>
//               <ControlledTextInputField
//                 name={field.name}
//                 control={control}
//                 label={field.label}
//                 multiple={field.multiple}
//                 placeholder={field.placeholder}
//                 // disabled={field.disabled}
//                 options={field.options}
//                 rules={field.rules}
//                 instantBooking={field.instantBooking}
//                 type={field.type}
//                 error={!!errors[field.name]}
//                 helperText={errors[field.name]?.message}
//               />
//             </Grid>
//           ))}
//           <Grid item xs={12} sm={6}>
//             <StatusRadioGroup
//               name={"status"}
//               control={control}

//               defaultValue={status}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <Box className="button-container">
//               <CustomButton
//                 variant="contained"
//                 className="cancel-button"
//                 type="button"
//                 text="Back"
//                 link={-1}
//               />
//               <CustomButton
//                 variant="contained"
//                 className="success-button"
//                 type="submit"
//                 loading={updatePromoCodeLoading}

//                 text={"Edit"}
//               />
//             </Box>
//           </Grid>
//         </Grid>
//       </form>
//       <ToastContainer />
//     </Box>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import {
  addAirportRequest,
  resetAirportState,
} from "../../redux/Airports/actions/airportActions";
import {
  selectCountryAirportRequest,
  selectStateAirportRequest,
} from "../../redux/Common/selectorAction";

import {
  AIRPORTS,
  EDITPROMO,
  PROMOCODE,
} from "../../component/common/Routes/AppRoutes";
import { useNavigate, useParams } from "react-router-dom";
import {
  LocationOn,
  FlightLand,
  FlightTakeoff,
  TransferWithinAStation,
} from "@mui/icons-material";
import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import TextInputField from "../../component/ui/FormFields/TextInputField";
import {
  resetUpdatePromoCode,
  updatePromoCodeRequest,
  viewPromoCodeRequest,
} from "../../redux/PromoCode/PromoCodeAction";
import { convertDateFormat, formatDateWithAmPm } from "../../Style";
import Loading from "../../component/ui/Loading";

export default function EditPromoCode() {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
    mode: "onChange",
  });
  const formValue = watch();
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.promoCode.viewPromoCode.loading);
  const updatePromoCodeLoading = useSelector(
    (state) => state.promoCode.updatePromoCode.loading
  );
  const updatePromoCodeSuccess = useSelector(
    (state) => state.promoCode.updatePromoCode.success
  );
  const updatePromoCodeError = useSelector(
    (state) => state.promoCode.updatePromoCode.error
  );
  const navigate = useNavigate();

  const promoCodeDetails = useSelector(
    (state) => state.promoCode?.viewPromoCode?.data || {}
  );

  let status = promoCodeDetails?.status === 1 ? "Active" : "Inactive";
  const { id } = useParams();

  const [discountType, setDiscountType] = useState();

  const promoFields = [
    {
      name: "title",
      label: "Title *",

      placeholder: "Enter PromoCode Title",
      rules: { required: "Discount Title is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_code",

      label: "Discount Code *",
      placeholder: "Enter Discount Code",
      rules: {
        required: "Discount Code is required",
        validate: (value) => {
          if (value.length < 4) {
            return "Discount Code must be at least 4 characters";
          }

          return true;
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_type",
      label: "Discount Type",
      placeholder: "Select Discount Type",
      options: [
        { value: "2", label: "Price ($)" },
        { value: "1", label: "Discount(%)" },
      ],
      rules: {
        required: "Select Discount Type",
      },
      sm: 6,
      xs: 12,
    },
    ...(discountType == "2"
      ? [
          {
            name: "discount_value",
            label: "Discount Value *",
            placeholder: "Enter Discount Value",
            rules: { required: "Discount Value is required" },
            sm: 6,
            xs: 12,
          },
        ]
      : [
          {
            name: "discount_percent",
            label: "Discount Percentage *",
            placeholder: "Enter Discount Percentage 0-100%",
            rules: {
              required: "Percentage is required",
              min: { value: 0, message: "Percentage should not be negative" },
              max: {
                value: 100,
                message: "Percentage must be less than or equal to 100",
              },
            },
            sm: 6,
            xs: 12,
          },
        ]),
    {
      name: "usage_limit",
      label: "Use Limit *",

      placeholder: "Set Promo Code Use Limit",
      rules: {
        required: "Promo Code Limit is Required",
        min: { value: 1, message: "Usage limit must greater than 0" },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "valid_from",
      label: "Valid From *",
      placeholder: "Select date",
      type: "datebooking",
      instantBooking: "true",
      rules: {
        required: "Date is required",
        validate: {
          notPastDate: (value) => {
            if (!value) return true;

            console.log("Input value:", value);

            // Parse DD-MM-YYYY format into Date object
          const [day, month, year] = value.split(/[-/]/);

            if (!day || !month || !year) return "Invalid date format";

            const inputDate = new Date(`${year}-${month}-${day}`);
            // if (isNaN(inputDate.getTime())) return "Invalid date";

            // Get today's date without time
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            console.log("InputDate:", inputDate, "Today:", today);

            return inputDate >= today || "Cannot select past dates";
          },
        },
      },
      xs: 12,
      sm: 6,
    },
  {
  name: "valid_to",
  label: "Valid To *",
  placeholder: "Select date",
  type: "datebooking",
  instantBooking: "true",
  rules: {
    required: "Date is required",
validate: (value) => {
  if (!formValue.valid_from || !value) return true;

  // Normalize both dates to use "-" instead of "/"
  const fromDateStr = formValue.valid_from.replace(/\//g, "-");
  const toDateStr = value.replace(/\//g, "-");

  // Split into components
  const [fromDay, fromMonth, fromYear] = fromDateStr.split("-");
  const [toDay, toMonth, toYear] = toDateStr.split("-");

  // Create Date objects for comparison
  const fromDate = new Date(Number(fromYear), Number(fromMonth) - 1, Number(fromDay));
  const toDate = new Date(Number(toYear), Number(toMonth) - 1, Number(toDay));

  // Optional: log normalized format
  console.log("Valid From:", `${fromDay}-${fromMonth}-${fromYear}`);
  console.log("Valid To:", `${toDay}-${toMonth}-${toYear}`);

  // Validation check
  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
    return "Invalid date format";
  }

  return (
    toDate >= fromDate ||
    "Valid To date must be greater than or equal to Valid From date"
  );
}

  },
  xs: 12,
  sm: 6,
}
,
    {
      name: "applicable_platform",
      label: "Applicable Platform *",
      placeholder: "Select Platform",
      options: [
        { value: 1, label: "Web" },
        { value: 2, label: "App" },
        { value: 3, label: "Both" },
      ],
      rules: {
        required: "Please select a platform",
      },
      xs: 12,
      sm: 6,
    },
    {
      name: "description",
      label: "Description ",
      placeholder: "Enter Promo Code Description ",
      type: "textarea",
      xs: 12,
    },
  ];

  useEffect(() => {
    if (formValue.discount_type?.value == "1") {
      setValue("discount_value", "");
    } else {
      setValue("discount_percent", "");
    }
  }, [formValue.discount_type]);

  useEffect(() => {
    setDiscountType(formValue?.discount_type?.value);
  }, [formValue.discount_type]);

  useEffect(() => {
    if (id) {
      dispatch(viewPromoCodeRequest(id));
    }
  }, [id]);

  useEffect(() => {
    if (Object.keys(promoCodeDetails).length > 0) {
      setValue("title", promoCodeDetails.title);
      setValue("discount_code", promoCodeDetails.discount_code);
      setValue(
        "discount_type",
        promoCodeDetails.discount_type === 2
          ? { value: "2", label: "Price ($)" }
          : { value: "1", label: "Discount (%)" }
      );
      setValue("discount_value", promoCodeDetails.discount_value);
      setValue("discount_percent", promoCodeDetails.discount_percent);
      setValue("usage_limit", promoCodeDetails.usage_limit);
      setValue("valid_from", formatDateWithAmPm(promoCodeDetails.valid_from));
      setValue("valid_to", formatDateWithAmPm(promoCodeDetails.valid_to));
      setValue(
        "applicable_platform",
        promoCodeDetails.applicable_platform == 1
          ? { value: 1, label: "Web" }
          : promoCodeDetails.applicable_platform == 2
          ? { value: 2, label: "App" }
          : { value: 3, label: "Both" }
      );
      setValue("description", promoCodeDetails.description);
      setValue("status", promoCodeDetails.status === 1 ? "Active" : "Inactive");
    }
  }, [promoCodeDetails]);

  const onSubmit = (data) => {
        console.log("data", data)
    const formattedData = {
      ...data,
  
      id: id,
      valid_from: convertDateFormat(data.valid_from),
      valid_to: convertDateFormat(data.valid_to),
      discount_type: data.discount_type.value,
      discount_percent: data.discount_percent || 0,
      discount_value: data.discount_value || 0,
      status: data.status === "Active" ? "1" : "2",
      applicable_platform: data.applicable_platform.value,
    };
    dispatch(updatePromoCodeRequest(formattedData));
  };

  if (loading) {
    return <Loading text="Loading Promo Code Details..." />;
  }

  if (updatePromoCodeSuccess) {
    toast.success(updatePromoCodeSuccess, {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetUpdatePromoCode());
        navigate(PROMOCODE);
      },
    });
  }

  if (updatePromoCodeError) {
    toast.error(updatePromoCodeError, {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetUpdatePromoCode());
      },
    });
  }

  return (
    <Box
      className="container"
      sx={{
        padding: "20px",
        height: "100vh",
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#c1c1c1",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#a8a8a8",
        },
      }}
    >
      <Card>
        <CardContent className="card" sx={{ padding: "30px" }}>
          <Typography variant="h5" className="form-heading" mb={2}>
            Edit PromoCode
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              className="customer-form-margin"
            >
              {promoFields.map((field) => (
                <Grid item xs={field.xs} sm={field.sm} key={field.name}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    multiple={field.multiple}
                    placeholder={field.placeholder}
                    disabled={field.disabled}
                    options={field.options}
                    rules={field.rules}
                    instantBooking={field.instantBooking}
                    type={field.type}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={6}>
                <StatusRadioGroup
                  name={"status"}
                  control={control}
                  defaultValue={status}
                />
              </Grid>

              <Grid item xs={12}>
                <Box className="button-container">
                  <CustomButton
                    variant="contained"
                    className="cancel-button"
                    type="button"
                    text="Back"
                    link={-1}
                  />
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    loading={updatePromoCodeLoading}
                    text={"Edit"}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>

          <ToastContainer />
        </CardContent>
      </Card>
    </Box>
  );
}
